import { Box } from 'grid-styled'
import * as React from 'react'
import Layout from '../../components/Layout'
import { graphql, Link } from 'gatsby'
import Img from 'gatsby-image'

import Target from 'react-icons/lib/fa/bullseye'
import Award from 'react-icons/lib/fa/shield'
import Atlas from 'react-icons/lib/fa/skyatlas'
import Card from '../../components/Card'
import CTA from '../../components/CTA'

import {
  Cards,
  Container,
  Hero,
  HeroContent,
  HeroFigure,
  HeroMain,
  Text,
  Announcement
} from '../../components/styles'
import { Button } from '../../components/Button'
import FAQs from '../../components/FAQs'
import Form from '../../components/Form'
import Arrow from '../../components/Arrow'
import Testimonials from '../../components/Testimonials'
import { testimonials } from '../testimonials'
import { Helmet } from 'react-helmet'

export const faqsInfo = [
  {
    title: 'Common app development questions'
  },
  {
    answer: `Eventually, paper and offline systems become more work to maintain than they it is to fo the work itself. Rather than outsource this to a third party, another company, an employee of oldschool fixed, why not turn to the power of technology to run your complex business operations.`,
    question: 'What are the benefits of an internal app?'
  },
  {
    answer: `There's really no saying until we hear more about your project. We have yet to miss a deadline, so once we give you a timeframe, you can be sure we'll stick to it. Reach out to us today and to chat about your requirements.`,
    question: `How long does it take to develop my app?`
  },
  {
    answer: `Our designers are pretty good. In fact we're so confident that we leave you the right to make any changes or modifications or recommendations on everything we do. We're sure you'll love it, but we understand you have your own vision and requirements that you understand better than anyone.`,
    question: `What if I'm not happy with the designs?`
  },
  {
    answer: `Since every project is entirely unique. There is no one fixed price. We generally won't charge by the hour, this way you can have an exact figure for the total project cost and we are incentivised to work as fast as possible.`,
    question: `How much does it cost?`
  },
  {
    answer: `Our programmers have a history of security and hacking prevention, everything we do will be up to the latest standards in online security to ensure your customers personal data is safe and you don't have to deal with malicious competitors.`,
    question: `Will it be secure?`
  }
]

/* prettier-ignore */
interface IProps {
  data: {
    adjustments: {
      childImageSharp: {
        fluid: object
      }
    };
    research: {
      childImageSharp: {
        fluid: object
      }
    };
    flows: {
      childImageSharp: {
        fluid: object
      }
    };
    inf: {
      childImageSharp: {
        fluid: object
      }
    };
    programmer: {
      childImageSharp: {
        fluid: object
      }
    };
    hero: {
      childImageSharp: {
        fluid: object
      }
    };
  }
}

export default ({ data }: IProps) => (
  <Layout>
    <Helmet>
      <title>
        Business App Development - Next Generation Apps - Turboclicks
      </title>
      <meta
        name="description"
        content="We've helped thousands of businesses build internal business critical apps to power their entire operations pipeline. Can we help you too?"
      />
    </Helmet>
    <Hero>
      <Container>
        <HeroContent>
          <HeroMain>
            <h1>App development</h1>
            <p>
              For a free consultation on consumer facing web applications and
              internal business applications, contact us today.
            </p>
            <Announcement to="/">
              Speak with an app specialist
              <Arrow rotate="-90deg" />
            </Announcement>
            <Link to="/contact#form">
              <Button inverted={true}>Help me build my app</Button>
            </Link>
          </HeroMain>

          <HeroFigure>
            <Img
              fluid={data.hero.childImageSharp.fluid}
              alt="Turboclicks business application development Australia"
            />
          </HeroFigure>
        </HeroContent>
      </Container>
    </Hero>

    <Container padY={true}>
      <Cards>
        <Card
          color="primary"
          title="Experienced programmers"
          content="Our developers have worked on application projects with market leads such as Rebel Sport and Amart as well as with local indie startups with a passion for helping humanity. Whatever it is you need, we're capable of getting you there."
        >
          <Target />
        </Card>

        <Card
          color="tertiary"
          title="Full suite service"
          content="Our design, content, strategy and development pillars all work together to bring you the absolute best result, a product of synergistic people at work with technology."
        >
          <Award />
        </Card>

        <Card
          color="purple"
          title="Latest practices"
          content="We work in an evolving space. Technology, particularly web and application development is moving at a pace that is almost ridiculous. Fortunately, we love it and spend most of our spare time keeping up with the latest evolutionary stage of the theory and tooling."
        >
          <Atlas />
        </Card>
      </Cards>
    </Container>

    <Box mt={4}>
      <Container
        image="https://images.weserv.nl/?url=//i47.tinypic.com/r9206r.jpg&bri=-25&blur=20"
        full={true}
        padY={true}
      >
        <Container medium={true}>
          <h2>
            We've worked with some of the most biggest businesses in Australia.
            And we'd like to work with you too.
          </h2>
        </Container>
      </Container>
    </Box>

    <Container padY={true} medium={true}>
      <h3>Your own custom app</h3>

      <h5>Streamline complex business operations</h5>
      <Text size="large">
        After being in business for a while, you've probably found yourself in a
        bit of a slump. Your systems and processes have matured and may now even
        be holding you back. This is where Mobile, iPhone, Android and Web
        Application development can save the day. Having humans manage complex
        internal business operations of their of free will is inefficient and
        error-prone.
      </Text>
      <Text size="large">
        What is needed is simple, a little splash of technology. We've seen time
        and time again the power that online apps, portals, and systems have had
        on small, medium and large businesses alike. If you are struggling with
        inefficient operations in your business, giving us a call might be worth
        your time.
      </Text>

      <h5>Automate the boring stuff</h5>
      <Text size="large">
        One of the most powerful aspects of technology is certainly automation.
        When it comes to repeating, low-level yet potentially complex tasks with
        may moving pieces, a few lines of code will outperform a human every day
        of the week. We're just not built for that kind of stuff.
      </Text>
      <Text size="large">
        The good news is, with the right support and guidance, your new
        internal, online business systems will save you both time, mistakes and
        of course money. Saving just an hour of your time a day could directly
        account for thousands of dollars in cost, and generate thousands more in
        gained opportunities.
      </Text>

      <h5>Make your startup a reality</h5>
      <Text size="large">
        Not all startup founders are programmers. We get that. Sometimes a great
        idea, and vision really is what is takes. But what's needed still is
        great execution. This is where we step in. Our team of competent
        developers, designers and more can help guide your creation to it's
        fruition.
      </Text>
    </Container>

    <CTA
      inverted={true}
      title="Want to discuss your idea?"
      subtitle="We’d love to chat"
      button="Speak to a specialist"
    />

    <FAQs data={faqsInfo} flushTop={true} />

    <Testimonials testimonials={testimonials} />

    <Form />
  </Layout>
)

export const query = graphql`
  query AppDevelopmentPageQuery {
    hero: file(relativePath: { eq: "app-development.jpg" }) {
      childImageSharp {
        fluid(maxWidth: 1000) {
          ...GatsbyImageSharpFluid_tracedSVG
        }
      }
    }

    inf: file(
      relativePath: { eq: "turboclicks-theinflatablefactory-case.png" }
    ) {
      childImageSharp {
        fluid(maxWidth: 1000) {
          ...GatsbyImageSharpFluid
        }
      }
    }

    adjustments: file(relativePath: { eq: "man-programming.jpg" }) {
      childImageSharp {
        fluid(maxWidth: 1000) {
          ...GatsbyImageSharpFluid
        }
      }
    }
  }
`
